//
//  EASY PANORAMA
//
//
//
//
//
//

import { panoramas, types, originCacheBuster, getEventEmitter } from './PanoPlayer'
const Panorama = require('./Panorama.js').default
const CanvasManager = require('./CanvasManager.js').default
let eventEmitter
export default function EasyPanorama() {
    Panorama.apply(this, arguments)
    this.rootType = types.EASY

    this.geometry = new THREE.SphereGeometry(this.player.viewerWidth * 4, 128, 64)

    this.texture = this.player.options.texture || new THREE.Texture()
    this.texture.minFilter = THREE.LinearFilter
    this.imageLoaded = false
    // this.loadedImage = this.loadedImage.bind(this)

    this.element = CanvasManager.getCanvas()
    this.renderer = new THREE.WebGLRenderer({ antialias: true, canvas: this.element })

    this.createEasyMesh = (size, cb) => {
        this.shape = types.EASY

        var scope = this,
            imgSrc = this.getTileUrl(null, this.player.zoom, this),
            // imgSrc = this.getTileUrl(null, size == this.lowQuality ? 0 : this.player.zoom, this),
            image = new Image(),
            mesh

        image.crossOrigin = 'anonymous'
        if (this.player.options.path) {
            image.onload = function() {
                if (typeof cb == 'function') cb()
                // If highres image loaded no need to update texture to lowres
                if (scope.imageLoaded && size == scope.lowQuality) return

                requestAnimationFrame(() => {
                    scope.texture.image = image
                    scope.texture.needsUpdate = true
                    scope.player.requestUpdate()
                })

                if (!scope.player.viewReadyFired) {
                    eventEmitter.emit('viewReady', scope.player)
                }
                if (size !== scope.lowQuality) {
                    eventEmitter.emit('panoLoaded', scope.player)
                }
            }

            image.src = imgSrc
        }

        mesh = new THREE.Mesh(this.geometry, this.material)
        // mesh.receiveShadow = true

        mesh.scale.x = -1
        this.meshes.push(mesh)
    }

    this.loadedImage = () => {
        this.imageLoaded = true

        // if (typeof this.lqIndex != 'undefined' && this.lqIndex in this.meshes && !this.destroying) {
        //     this.scene.remove(this.meshes[this.lqIndex])

        //     var mesh = this.meshes.splice(this.lqSphereIndex, 1)[0]

        //     mesh.material.dispose()
        //     mesh.geometry.dispose()
        // }
    }

    this.generateShader = function() {
        //Easy cap parameters. Hardcoded for now, but turn in to PHP lookup eventually?
        //the following parameters were generated by: ffmpeg -i input.jpg -vf equitoeasy=print_params=1 output.jpg
        ///////////////////////////
        var alim0 = 3.141592653589793116,
            alim1 = -3.141592653589793116, //limits of the horizontal equirectangular axis (=azimuth angle)
            blim0 = 1.570796326794896558,
            blim1 = -1.570796326794896558, //limits of the vertical equirectangular axis (=elevation angle)
            ulim0 = 3.1415927410125732422,
            ulim1 = -3.1415927410125732422, //limits of horizontal EASY axis
            vlim0 = 1,
            vlim1 = -1 //limits of the vertical EASY axis

        //these parameters must match the ffmpeg encoding parameters!
        var BLOCKSIZE = 16,
            POLE_OVERLAP_PIX = 1, //the OVERLAP_PIX params are all buffers to avoid bleeding across EASY sections
            RING_OVERLAP_PIX_AZ = 1,
            RING_OVERLAP_PIX_EL = 1,
            PROJ_OVERLAP_PIX_AZ = 1, //had to include despite wraparound due to VR Unity shader behavior
            PROJ_OVERLAP_PIX_EL = 1,
            NV_MIN = 160,
            NU_MIN = 512
        // MIN_NP = NV_MIN*NU_MIN;//size of the smallest size (k=1)

        var R = 4, //number of EASY rings, including polar cap
            n = [1, 6, 10, 15], //number of tiles per ring
            phi = [1.4589346132593310479, 1.2739031247656165124, 1.1056367510067890425, 0.92729520797729492188] //elevations of bottom edges of rings
        ///////////////////////////

        //calculable EASY params
        var ring_ulim0 = [],
            ring_ulim1 = [],
            ring_vlim0,
            ring_vlim1,
            proj_a2u_m,
            proj_a2u_b,
            proj_b2v_m,
            proj_b2v_b,
            cumsum_n = [],
            N,
            cap_thresh_left,
            cap_thresh_top,
            polar_radius

        //v limits of the top ring section, not including overlap
        ring_vlim0 = RING_OVERLAP_PIX_EL
        ring_vlim1 = BLOCKSIZE - RING_OVERLAP_PIX_EL

        //precalculate slope and offset for linear interpolations for central projection so that pixel overlaps are handled properly
        proj_a2u_m = (1.0 - (2.0 * PROJ_OVERLAP_PIX_AZ) / NU_MIN) / (ulim1 - ulim0)
        proj_a2u_b = -ulim0 * proj_a2u_m + PROJ_OVERLAP_PIX_AZ / NU_MIN

        var CC = PROJ_OVERLAP_PIX_EL / (NV_MIN / 2.0 - BLOCKSIZE)
        proj_b2v_m = (1.0 - CC) / (vlim1 - vlim0)
        proj_b2v_b = -vlim0 * proj_b2v_m + (BLOCKSIZE * CC + PROJ_OVERLAP_PIX_EL) / NV_MIN

        cumsum_n[0] = n[0]
        for (var ii = 1; ii < R; ++ii) {
            cumsum_n[ii] = cumsum_n[ii - 1] + n[ii]
            ring_ulim0[ii - 1] = cumsum_n[ii - 1] * BLOCKSIZE + RING_OVERLAP_PIX_AZ
            ring_ulim1[ii - 1] = cumsum_n[ii] * BLOCKSIZE - RING_OVERLAP_PIX_AZ
        }
        N = cumsum_n[R - 1]

        cap_thresh_left = lerp(0.0, NU_MIN, ulim0, ulim1, BLOCKSIZE)
        cap_thresh_top = Math.sin(phi[R - 1])
        polar_radius = blim0 - phi[0] + lerp(0.0, BLOCKSIZE, 0.0, 2.0 * (blim0 - phi[0]), POLE_OVERLAP_PIX)
        //end Easy cap parameters

        function buildRings() {
            var rings = ''
            for (var ii = 1; ii < R; ++ii) {
                rings +=
                    (ii == 1 ? 'if' : 'else if') +
                    '((abs(b)<=' +
                    phi[ii - 1].toFixed(20) +
                    ') && (abs(b)>' +
                    phi[ii].toFixed(20) +
                    ')){' +
                    'u = lerp(' +
                    alim0.toFixed(20) +
                    ',' +
                    alim1.toFixed(20) +
                    ',' +
                    ring_ulim0[ii - 1].toFixed(20) +
                    ',' +
                    ring_ulim1[ii - 1].toFixed(20) +
                    ', a);' +
                    'u = lerp(0.0,' +
                    NU_MIN.toFixed(20) +
                    ',' +
                    ulim0.toFixed(20) +
                    ',' +
                    ulim1.toFixed(20) +
                    ', u);' +
                    'v = lerp(' +
                    phi[ii - 1].toFixed(20) +
                    ',' +
                    phi[ii].toFixed(20) +
                    ',' +
                    ring_vlim0.toFixed(20) +
                    ',' +
                    ring_vlim1.toFixed(20) +
                    ', abs(b));' +
                    'v = lerp(0.0,' +
                    NV_MIN.toFixed(20) +
                    ',' +
                    vlim0.toFixed(20) +
                    ',' +
                    vlim1.toFixed(20) +
                    ', v);' +
                    '}'
            }

            return rings + 'else{' + 'u = 0.0;' + 'v = 0.0;' + '} '
        }

        function lerp(alim0, alim1, ulim0, ulim1, a) {
            var u = ((a - alim0) / (alim1 - alim0)) * (ulim1 - ulim0) + ulim0

            return u
        }

        var fragmentShaderTxt =
            'uniform sampler2D texture;' +
            'varying vec2 vUv;' +
            'float uv2a(in float u, in float v)' +
            '{' +
            'return sqrt(u*u + v*v)*min(abs(1.0/cos(atan(v,u))),abs(1.0/cos(abs(' +
            Math.PI.toFixed(20) +
            '/2.0 - atan(v,u)))))*cos(atan(v,u));' +
            '}' +
            'float uv2b(in float u, in float v)' +
            '{' +
            'return sqrt(u*u + v*v)*min(abs(1.0/cos(atan(v,u))),abs(1.0/cos(abs(' +
            Math.PI.toFixed(20) +
            '/2.0 - atan(v,u)))))*sin(atan(v,u));' +
            '}' +
            'float lerp(in float alim0, in float alim1, in float ulim0, in float ulim1, in float a)' +
            '{' +
            'return ((a - alim0)/(alim1 - alim0)*(ulim1 - ulim0) + ulim0);' +
            '}' +
            'vec2 azel2caps_ffmpeg(vec2 UV){' +
            'float a;' +
            'float b;' +
            'float u;' +
            'float v;' +
            'float az_cap;' +
            'float el_cap;' +
            'float ringSign;' +
            'a = lerp(0.0,1.0,' +
            alim0.toFixed(20) +
            ',' +
            alim1.toFixed(20) +
            ',UV.x);' +
            'b = lerp(0.0,1.0,' +
            blim0.toFixed(20) +
            ',' +
            blim1.toFixed(20) +
            ',UV.y);' +
            'if(abs(b)<=asin(' +
            cap_thresh_top +
            ')){' +
            'u = a*' +
            proj_a2u_m.toFixed(20) +
            ' + ' +
            proj_a2u_b.toFixed(20) +
            ';' +
            'v = sin(b)*' +
            proj_b2v_m.toFixed(20) +
            ' + ' +
            proj_b2v_b.toFixed(20) +
            ';' +
            '}else{' +
            'ringSign = 1.0 - 2.0*float(b<0.0);' +
            'if(abs(b)>=' +
            phi[0].toFixed(20) +
            '){' +
            //polar cap
            'az_cap = atan(sin(a),ringSign*tan(b))/' +
            polar_radius.toFixed(20) +
            ';' +
            'el_cap = -asin(-ringSign*cos(a)*cos(b))/' +
            polar_radius.toFixed(20) +
            ';' +
            'u = lerp(-1.0,1.0,' +
            ulim0.toFixed(20) +
            ',' +
            cap_thresh_left.toFixed(20) +
            ',uv2a(az_cap,el_cap));' +
            'v = lerp(-1.0,1.0,' +
            vlim0.toFixed(20) +
            ',' +
            cap_thresh_top.toFixed(20) +
            ',ringSign*uv2b(az_cap,el_cap));' +
            '}else{ ' +
            // 	//rings in cap
            buildRings() +
            '}' +
            'u = (u - (' +
            ulim0.toFixed(20) +
            '))/((' +
            ulim1.toFixed(20) +
            ') - (' +
            ulim0.toFixed(20) +
            '));' +
            'v = (ringSign*v - (' +
            vlim0.toFixed(20) +
            '))/((' +
            vlim1.toFixed(20) +
            ') - (' +
            vlim0.toFixed(20) +
            '));' +
            '}' +
            'return vec2(u,v);' +
            '}' +
            'void main() {' +
            '	gl_FragColor = texture2D(texture, azel2caps_ffmpeg(vUv));' +
            '}'

        var vertexShader =
            'attribute vec2 a_position;' +
            'varying vec2 vUv;' +
            'void main() {' +
            '	vUv = uv;' +
            '	gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0);' +
            '}'

        return {
            fragment: fragmentShaderTxt,
            vertex: vertexShader,
        }
    }

    // NOTE: MOVE THIS INTO PANORAMA DESTROY IF NECESSARY
    // this.destroy = function() {
    //     this.destroying = true
    //     console.log('+++++', Panorama);
    //     Panorama.destroy.call(this)

    //     this.texture && this.texture.dispose()
    //     this.geometry && this.geometry.dispose()
    //     this.material && this.material.dispose()

    //     for (var index in this.meshes) {
    //         var mesh = this.meshes[index]

    //         mesh.geometry.dispose()
    //         mesh.material.dispose()
    //     }
    // }

    this._getTileUrl = function(path, size, coord) {
        return originCacheBuster(path + 'easy/' + size + '.jpg')
    }

    eventEmitter = getEventEmitter()

    var shader = this.player.options.shader || this.generateShader()

    this.material = new THREE.ShaderMaterial({
        uniforms: {
            texture: { type: 't', value: this.texture },
        },
        vertexShader: shader.vertex,
        fragmentShader: shader.fragment,
        side: THREE.BackSide,
    })

    // NOTE: This has to come after material is defined for image to load.  Should find a better solution.
    this.createEasyMesh(null, this.loadedImage)

    this.lowQuality = 512

    if (this.player.zoom > 1) {
        this.lqIndex = 0
        this.createEasyMesh(this.lowQuality)
    }

    return this
}
